export enum PatientMonitorSelectorType {
  FAMILY = "FAMILY",
  VARIANT = "VARIANT",
  SENSOR = "SENSOR",
  MOUNTING_GROUP = "MOUNTING_GROUP",
  MOUNTING_ARM = "MOUNTING_ARM",
  ATTACHMENTS = "ATTACHMENTS",
  OVERVIEW = "OVERVIEW",
}

export enum TelemetrySelectorType {
  FAMILY = "FAMILY",
  SENSOR = "SENSOR",
  ADDITIONAL_BATTERIES = "ADDITIONAL_BATTERIES",
  OVERVIEW = "OVERVIEW",
}

export enum CentralStationsSelectorType {
  FAMILY = "FAMILY",
  LICENCE = "LICENCE",
  ADDITIONAL_LICENCES = "ADDITIONAL_LICENCES",
  ACCESSORIES = "ACCESSORIES",
  OVERVIEW = "OVERVIEW",
}
